class OptionDrawings extends HTMLElement {
  constructor() {
    super();

    this.drawings = [...this.querySelectorAll('[data-drawing]')];
    this.options = [...this.querySelectorAll('[data-option]')];
    this.updates = [...this.querySelectorAll('[data-update]')];
    this.saveButton = this.querySelector('[data-save]');

    this.selectedOption = {
      name: this.dataset.initialName,
      value: this.dataset.initialValue,
    }

    this.addEventListeners = this.addEventListeners.bind(this);
    this.addEventListeners();
  }

  addEventListeners() {
    this.options.forEach((option) => {
      option.addEventListener('click', () => {
        this.updateState(option);
        this.updateShownImage(option);
        this.updateElements(option);
      });
    });

    this.saveButton.addEventListener('click', this.saveAndClose.bind(this));
  }

  saveAndClose() {
    const variantSelectorOption = document.querySelector(
      `input[data-option-name="${this.selectedOption.name}"][value="${this.selectedOption.value}"]`
    );

    if (variantSelectorOption){
      variantSelectorOption.click();


      const activeProductOptions = document.querySelectorAll('.gr-option-wrapper input:checked');
      activeProductOptions.forEach(activeProductOption => {
        const item = activeProductOption.closest('.HorizontalList__Item');
        item.parentElement.scrollLeft = item.offsetLeft
      });
    }
    this.parentNode.close();
    document.body.classList.remove('overflow-hidden');
  }

  updateState(option) {
    this.selectedOption = {
      name: option.dataset.name,
      value: option.dataset.value,
    };
  }

  updateShownImage(option) {
    this.drawings.forEach((drawing) => {
      const { name, value } = drawing.dataset;
      drawing.hidden = name !== option.dataset.name || value !== option.dataset.value;
    });
  }

  updateElements(option) {
    this.updates.forEach((update) => {
      switch (update.dataset.update) {
        case 'name':
          update.textContent = option.dataset.name;
          break;

        case 'value':
          update.textContent = option.dataset.value;
          break;

        case 'active-option':
          this.options.forEach((option) => option.classList.remove('active'));
          option.classList.add('active');
          break;

        default:
          break;
      }
    });
  }
}

customElements.define('option-drawings', OptionDrawings);